export default {
  // Navigation
  "nav.expenses": "Kulukorvaukset",
  "nav.expense_categories_configuration": "Kululajit",

  // Expense Categories
  "expense_categories.title": "Kululajit",
  "expense_categories.code": "Koodi",
  "expense_categories.name": "Nimi",
  "expense_categories.unit_price": "Yksikköhinta",
  "expense_categories.unit": "Yksikkö",
  "expense_categories.state": "Tila",
  "expense_categories.select_tenant": "Valitse ensin yritys.",
  "expense_categories.delete_confirm": "Haluatko varmasti poistaa tämän kululajin?",
  "expense_categories.created": "Kululaji luotu onnistuneesti",
  "expense_categories.updated": "Kululaji päivitetty onnistuneesti",
  "expense_categories.error.code_required": "Koodi on pakollinen",
  "expense_categories.error.name_required": "Nimi on pakollinen",

  // List
  "expenses.title": "Kulukorvaukset",
  "expenses.number": "Numero",
  "expenses.description": "Kuvaus",
  "expenses.date": "Päivämäärä",
  "expenses.employee": "Työntekijä",
  "expenses.manager": "Esimies",
  "expenses.paid_by": "Maksaja",
  "expenses.paid_by_employee": "Työntekijä (korvattava)",
  "expenses.paid_by_company": "Yritys",
  "expenses.total": "Yhteensä",
  "expenses.state": "Tila",
  "expenses.currency": "Valuutta",
  "expenses.notes": "Muistiinpanot",
  "expenses.select_tenant": "Valitse ensin yritys.",
  "expenses.delete_confirm": "Haluatko varmasti poistaa tämän kulukorvauksen?",

  // States
  "expenses.state.draft": "Luonnos",
  "expenses.state.deleted": "Poistettu",
  "expenses.state.submitted": "Lähetetty",
  "expenses.state.approved": "Hyväksytty",
  "expenses.state.posted": "Kirjattu",
  "expenses.state.paid": "Maksettu",
  "expenses.state.refused": "Hylätty",

  // Form
  "expenses.new": "Uusi kulukorvaus",
  "expenses.created": "Kulukorvaus luotu onnistuneesti",
  "expenses.updated": "Kulukorvaus päivitetty onnistuneesti",
  "expenses.section.basic": "Perustiedot",
  "expenses.section.rows": "Kulurivit",

  // Form validation
  "expenses.error.description_required": "Kuvaus on pakollinen",
  "expenses.error.date_required": "Päivämäärä on pakollinen",
  "expenses.error.employee_required": "Työntekijä on pakollinen",
  "expenses.error.account_required": "Tili on pakollinen",

  // Row columns
  "expenses.row.description": "Kuvaus",
  "expenses.row.account": "Tili",
  "expenses.row.amount": "Summa",
  "expenses.row.vat": "ALV",
  "expenses.row.vat_amount": "ALV-summa",
  "expenses.row.total": "Yhteensä",
  "expenses.row.category": "Kategoria",
  "expenses.row.quantity": "Määrä",
  "expenses.row.unit_price": "Yksikköhinta",
  "expenses.row.paid_by": "Maksaja",
  "expenses.add_row": "Lisää rivi",

  // Workflow actions
  "expenses.action.submit": "Lähetä",
  "expenses.action.submitting": "Lähetetään...",
  "expenses.action.approve": "Hyväksy",
  "expenses.action.approving": "Hyväksytään...",
  "expenses.action.refuse": "Hylkää",
  "expenses.action.refusing": "Hylätään...",
  "expenses.action.post": "Kirjaa",
  "expenses.action.posting": "Kirjataan...",
  "expenses.action.reset": "Palauta luonnokseksi",
  "expenses.action.resetting": "Palautetaan...",

  // Workflow messages
  "expenses.submitted": "Kulukorvaus lähetetty hyväksyttäväksi",
  "expenses.approved": "Kulukorvaus hyväksytty",
  "expenses.refused": "Kulukorvaus hylätty",
  "expenses.posted": "Kulukorvaus kirjattu kirjanpitoon",
  "expenses.reset": "Kulukorvaus palautettu luonnokseksi",

  // Attachments
  "attachments.title": "Liitteet",
  "attachments.none": "Ei liitteitä",
  "attachments.upload": "Lataa",
  "attachments.uploaded": "Liite ladattu",
  "attachments.deleted": "Liite poistettu",
  "attachments.upload_error": "Liitteen lataus epäonnistui",
  "attachments.delete_error": "Liitteen poisto epäonnistui",
  "attachments.download_error": "Liitteen lataus epäonnistui",
};
